<template>
  <div class="ai-tool-badge-wrapper">
    <!-- AI Tool Badge (outside WidgetTool, positioned next to main badge via left/top) -->
    <b-badge
      v-if="showBadge"
      id="widget-ai-tool-badge"
      pill
      variant="light"
      class="ai-tool-badge widget-tool border-white d-flex align-items-center p-4"
      :class="{ 'ai-tool-active': isAIToolActive }"
      :style="aiToolBadgeComputedStyle"
    >
      <div
        class="cursor-pointer btn-tool"
        :class="{ 'ai-icon-active': isAIToolActive }"
        @click.stop="onBadgeClick"
        v-b-tooltip.hover
        :title="$t('engine.floatframeTool.btnHover.tooltip.lblAI', languageEngine)"
      >
        <img :src="require('@assets/images/icon/ai_generate.svg')" style="width: 20px; height: 20px">
      </div>
    </b-badge>

    <!-- AI Option Dropdown (outside WidgetTool, inside Wrapper — same pattern as AIGenerate) -->
    <div
      v-if="showDropdown"
      id="ai-option-container"
      class="ai-option-tool"
      :style="positionAIOptionTool"
      @click.stop
    >
      <AIOption
        :position="{ top: '0px', left: '0px' }"
        :options="aiOptionItems"
        @option-click="$emit('option-click', $event)"
        @submenu-click="$emit('submenu-click', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AIOption from '@components_system/Design/AIGenerate/Menu/AIOption.vue';

export default {
  name: 'AIToolBadge',
  components: {
    AIOption,
  },
  props: {
    showBadge: {
      type: Boolean,
      default: false,
    },
    isAIToolActive: {
      type: Boolean,
      default: false,
    },
    aiToolBadgeComputedStyle: {
      type: Object,
      default: () => ({}),
    },
    showDropdown: {
      type: Boolean,
      default: false,
    },
    positionAIOptionTool: {
      type: Object,
      default: () => ({}),
    },
    aiOptionItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      languageEngine: 'designIframe/userPreference/languageEngine',
    }),
  },
  methods: {
    onBadgeClick(event) {
      this.$emit('badge-click', event);
    },
  },
};
</script>

<style scoped lang="scss">
$ai-cyan: #28bee3;
$ai-purple: #7a5af8;
$ai-pink: #ee46bc;
$ai-border: #dee3e6;
$ai-shadow-cyan: rgba(40, 190, 227, 0.15);
$ai-shadow-pink: rgba(238, 70, 188, 0.15);
$ai-gradient: linear-gradient(61deg, $ai-cyan 0%, $ai-purple 49.73%, $ai-pink 99.45%);

.ai-tool-badge-wrapper {
  .badge {
    background: #ffffff !important;
    border: 1px solid $ai-border !important;
    font-weight: normal;

    &:hover,
    &.ai-tool-active {
      background: $ai-gradient !important;
    }

    .btn-tool {
      &.ai-icon-active img,
      &:hover img {
        filter: brightness(0) invert(1);
      }
    }
  }

  .ai-tool-badge {
    position: absolute;
    z-index: 5;
    pointer-events: all;
    height: 30px;
    border: 1px solid #ffffff !important;
    box-shadow: -2px 4px 16px 0 $ai-shadow-cyan, 2px -4px 16px 0 $ai-shadow-pink;
    font-weight: 500;
    line-height: 1;
    font-size: 20px;
  }

  .ai-option-tool {
    position: absolute;
    z-index: 10000;
    pointer-events: all;
  }
}
</style>
